import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

import { Modal } from '@/components/Modal/Modal';

type Props = {
	handleHideUnsavedDialog: () => void;
	onClose: () => void;
	open: boolean;
};

export const DiscardChangesWarningModal = ({
	handleHideUnsavedDialog,
	onClose,
	open
}: Props) => {
	const { t } = useTranslation();

	return (
		<Modal
			open={open}
			hideCloseButton
			size='xs'
			title={t('Discard Changes?')}
			footer={
				<>
					<Button onClick={handleHideUnsavedDialog} variant='text'>
						{t('CONTINUE EDITING')}
					</Button>

					<Button
						variant='contained'
						onClick={() => {
							handleHideUnsavedDialog();
							onClose();
						}}
					>
						{t('DISCARD')}
					</Button>
				</>
			}
		>
			<Typography color='text.secondary'>
				{t(
					'You have unsaved changes in this request. If you leave now, your updates will be lost.'
				)}
			</Typography>
		</Modal>
	);
};
